export default function Hero() {
  return (
    <section className="relative h-screen min-h-[700px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Sleek%20modern%20white%20sneakers%20floating%20above%20a%20reflective%20glass%20platform%20with%20vibrant%20neon%20rim%20lighting%20in%20coral%20pink%20and%20mint%20green%20hues%2C%20dramatic%20studio%20lighting%2C%20futuristic%20product%20showcase%20with%20bold%20shadows%20and%20negative%20space%2C%20high%20contrast%20editorial%20photography%2C%20sharp%20details%20on%20textile%20and%20rubber%20textures%2C%20visually%20striking%20commercial%20composition&width=1800&height=1200&seq=hero-bg-v2-x9q7m&orientation=landscape"
          alt="GTBuy Spreadsheet fashion sourcing products flat lay"
          title="GTBuy Spreadsheet Hub - Verified Product Categories"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 h-full w-full flex flex-col justify-center px-6 md:px-10 lg:px-16">
        <div className="lg:ml-auto lg:mr-0 lg:w-[55%] text-left">
          <p className="text-background-50/70 text-xs tracking-[0.3em] uppercase mb-6 font-medium">
            Independent SEO Hub
          </p>
          <h1 className="text-background-50 font-heading text-5xl md:text-7xl lg:text-[82px] font-light leading-[1.08] mb-6">
            GTBuy<br />
            Spreadsheet<br />
            Hub 2026
          </h1>
          <p className="text-background-50/80 text-base md:text-lg font-light max-w-lg mb-10 leading-relaxed">
            Independent reviews &amp; verified category links to kaspreadsheet.com. Discover the best spreadsheet sourcing platforms in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 bg-background-50 text-foreground-900 px-7 py-3.5 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer group"
            >
              GTBuy Sheet
              <span className="w-7 h-7 flex items-center justify-center bg-foreground-900 rounded-full group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 bg-background-50 text-foreground-900 px-7 py-3.5 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer group"
            >
              Buy It Now
              <span className="w-7 h-7 flex items-center justify-center bg-foreground-900 rounded-full group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </a>
          </div>

          <div className="flex items-center gap-5 mt-10">
            <span className="flex items-center gap-1.5 text-background-50/70 text-xs">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              Updated daily
            </span>
            <span className="flex items-center gap-1.5 text-background-50/70 text-xs">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              Verified sources
            </span>
            <span className="flex items-center gap-1.5 text-background-50/70 text-xs">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              Safe browsing
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-[160px] overflow-hidden">
        <div className="flex gap-4 px-6 animate-scroll-horizontal">
          <div className="flex-shrink-0 w-[200px] h-[130px] rounded-2xl overflow-hidden bg-background-50/90 backdrop-blur-sm">
            <img
              src="https://readdy.ai/api/search-image?query=A%20single%20elegant%20high%20heel%20stiletto%20with%20pearl%20embellishments%20resting%20on%20a%20velvet%20burgundy%20cushion%2C%20warm%20candlelight%20ambiance%2C%20luxury%20boudoir%20setting%20with%20soft%20golden%20reflections%2C%20sophisticated%20product%20photography%20with%20rich%20jewel%20tones%20and%20dramatic%20chiaroscuro%20lighting&width=400&height=260&seq=hero-strip-v2-n3k8a&orientation=landscape"
              alt="Shoes"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="flex-shrink-0 w-[200px] h-[130px] rounded-2xl overflow-hidden bg-background-50/90 backdrop-blur-sm">
            <img
              src="https://readdy.ai/api/search-image?query=Oversized%20cable%20knit%20fisherman%20sweater%20draped%20casually%20on%20a%20weathered%20wooden%20dock%20overlooking%20misty%20morning%20lake%2C%20soft%20fog%20and%20diffused%20sunrise%20light%2C%20rustic%20outdoor%20lifestyle%20photography%2C%20sage%20green%20and%20oatmeal%20tones%20with%20natural%20texture%2C%20tranquil%20atmospheric%20composition&width=400&height=260&seq=hero-strip-v2-p5w2b&orientation=landscape"
              alt="Hoodies"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="flex-shrink-0 w-[200px] h-[130px] rounded-2xl overflow-hidden bg-background-50/90 backdrop-blur-sm">
            <img
              src="https://readdy.ai/api/search-image?query=Bright%20graphic%20print%20t-shirt%20hanging%20on%20a%20clothesline%20against%20a%20clear%20blue%20summer%20sky%20with%20fluffy%20white%20clouds%2C%20sunlit%20outdoor%20backyard%20setting%2C%20fresh%20and%20energetic%20lifestyle%20photography%2C%20vibrant%20pops%20of%20coral%20orange%20against%20crisp%20white%20fabric%2C%20joyful%20editorial%20style&width=400&height=260&seq=hero-strip-v2-r1j6c&orientation=landscape"
              alt="T-Shirts"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="flex-shrink-0 w-[200px] h-[130px] rounded-2xl overflow-hidden bg-background-50/90 backdrop-blur-sm">
            <img
              src="https://readdy.ai/api/search-image?query=Chunky%20gold%20chain%20necklace%20and%20stack%20of%20minimalist%20rings%20scattered%20on%20rough%20textured%20charcoal%20slate%20surface%2C%20strong%20directional%20side%20light%20creating%20dramatic%20metallic%20highlights%2C%20jewelry%20editorial%20photography%2C%20monochromatic%20dark%20gray%20palette%20with%20warm%20gold%20accents%2C%20bold%20contemporary%20composition&width=400&height=260&seq=hero-strip-v2-t9x4d&orientation=landscape"
              alt="Accessories"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
}